import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the serial number.
 */
export default function SerialNumberColumn({ data: { device } }: { data: RevisionPlanRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {device.serialNumber}
    </P2Regular>
  );
}
